const session_expired = {
    title: 'เซสชันหมดอายุ',
    subtitle: 'เซสชันของคุณอาจหมดอายุและคุณถูกตัดการเชื่อมต่อ กรุณาคลิกปุ่มด้านล่างเพื่อเข้าสู่ระบบคอนโซลผู้ดูแลระบบอีกครั้ง',
    button: 'เข้าสู่ระบบอีกครั้ง',
};
export default Object.freeze(session_expired);
